import { Pagination } from "services/search";

import {
  FleetVehicle,
  FleetVehicleColor,
  FleetVehicleEditFormValues,
  //   FuelType,
  //   Vehicle,
  //   VehicleColor,
  //   VehicleEditFormValues,
  //   VehicleImage,
  FleetVehicleRow,
  FleetVehicleStatusDetailFormValues,
  FleetVehicleStatusHistoryRow,
  VehicleImportResult,
  JomImportRequestItem,
  //   VehicleStatus,
} from "./types";

import { DataWithPagination } from "services/api/types";
import {
  transformFleetVehicle,
  transformFleetVehicleColor,
  transformFleetVehicleOnCreate,
  transformFleetVehicleOnUpdate,
  transformFleetVehicleRegistrationOnCreate,
  //   transformFuelTypes,
  //   transformVehicle,
  //   transformVehicleColor,
  //   transformVehicleImage,
  //   transformVehicleOnCreate,
  //   transformVehicleOnUpdate,
  transformFleetVehicleRow,
  transformFleetVehicleStatusDetailOnSave,
  transformFleetVehicleStatusHistoryRow,
  //   transformVehicleStatus,
} from "./transformations";
import { createApiCall, paginatedApiCall } from "services/api/createApiCall";
import { DropdownCacheKey, invalidateDropdownCache } from "services/hooks/useDropdownCache";
import { AxiosResponse } from "axios";
import { transformErrorResponse } from "services/api/transformation";
import { filesApi } from "services/api/config";
import { getAccessToken } from "services/auth";
// import { VehicleCategory } from "./categories/types";

// /*---------------------------------------------------------------------------------------
//   SEARCH
// -----------------------------------------------------------------------------------------*/
export const getFleetVehiclesAPI = async (
  pagination: Pagination,
  name?: string | null,
  vehicleManufacturerId?: string | null,
  vehicleModelId?: string | null,
  vehicleTypeId?: string | null,
  rentMonths?: number | null,
  rentKm?: number | null,
  availableNow?: boolean | null,
  additionalFilters?: {
    vinNumber?: string | null;
    firstRegistrationDateFrom?: Date | null;
    firstRegistrationDateTo?: Date | null;
    registrationPlate?: string | null;
    registrationExpirationFrom?: Date | null;
    registrationExpirationTo?: Date | null;
    kwFrom?: number | null;
    kwTo?: number | null;
    kmTraveledFrom?: number | null;
    kmTraveledTo?: number | null;
    condition?: string | null;
    fuelType?: string | null;
    statuses?: string[] | null;
    officeId?: string | null;
  }
): Promise<DataWithPagination<FleetVehicleRow>> => {
  let path = `/v1/fleet/vehicles?name=`;

  if (name) path += `${name}`;
  if (vehicleManufacturerId)
    path += `&vehicleManufacturerId=${vehicleManufacturerId}`;
  if (vehicleModelId) path += `&vehicleModelId=${vehicleModelId}`;
  if (vehicleTypeId) path += `&vehicleTypeId=${vehicleTypeId}`;
  if (rentMonths) path += `&rentMonths=${rentMonths}`;
  if (rentKm) path += `&rentKm=${rentKm}`;
  if (availableNow) path += `&availableNow=${availableNow}`;

  if (additionalFilters?.vinNumber)
    path += `&vinNumber=${encodeURIComponent(additionalFilters.vinNumber)}`;
  if (additionalFilters?.firstRegistrationDateFrom)
    path += `&firstRegistrationDateFrom=${additionalFilters.firstRegistrationDateFrom.toISOString()}`;
  if (additionalFilters?.firstRegistrationDateTo)
    path += `&firstRegistrationDateTo=${additionalFilters.firstRegistrationDateTo.toISOString()}`;
  if (additionalFilters?.registrationPlate)
    path += `&registrationPlate=${encodeURIComponent(additionalFilters.registrationPlate)}`;
  if (additionalFilters?.registrationExpirationFrom)
    path += `&registrationExpirationFrom=${additionalFilters.registrationExpirationFrom.toISOString()}`;
  if (additionalFilters?.registrationExpirationTo)
    path += `&registrationExpirationTo=${additionalFilters.registrationExpirationTo.toISOString()}`;
  if (additionalFilters?.kwFrom != null)
    path += `&kwFrom=${additionalFilters.kwFrom}`;
  if (additionalFilters?.kwTo != null)
    path += `&kwTo=${additionalFilters.kwTo}`;
  if (additionalFilters?.kmTraveledFrom != null)
    path += `&kmTraveledFrom=${additionalFilters.kmTraveledFrom}`;
  if (additionalFilters?.kmTraveledTo != null)
    path += `&kmTraveledTo=${additionalFilters.kmTraveledTo}`;
  if (additionalFilters?.condition)
    path += `&condition=${additionalFilters.condition}`;
  if (additionalFilters?.fuelType)
    path += `&fuelType=${encodeURIComponent(additionalFilters.fuelType)}`;
  additionalFilters?.statuses?.forEach((status) => {
    path += `&statuses=${encodeURIComponent(status)}`;
  });
  if (additionalFilters?.officeId)
    path += `&officeId=${encodeURIComponent(additionalFilters.officeId)}`;

  return await paginatedApiCall(path, pagination, transformFleetVehicleRow);
};

/*---------------------------------------------------------------------------------------
    INFO
  -----------------------------------------------------------------------------------------*/
export const getFleetVehicleAPI = async (id: string): Promise<FleetVehicle> => {
  const response = await createApiCall(
    {
      path: `/v1/fleet/vehicles/${id}`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformFleetVehicle(response.data);
};

/*---------------------------------------------------------------------------------------
    IMAGES
  -----------------------------------------------------------------------------------------*/
// export const getVehicleImagesAPI = async (id: string): Promise<VehicleImage> => {
//   const response = await createApiCall(
//     {
//       path: `/v1/catalog/vehicles/${id}/images`,
//       method: "GET",
//     },
//     {
//       getMessage: {
//         error: (error: any) => `${error.response.data.message}`,
//       },
//     }
//   )();

//   return transformVehicleImage(response.data);
// };

/*---------------------------------------------------------------------------------------
    CREATE
  -----------------------------------------------------------------------------------------*/
export const createFleetVehicleAPI = async (
  formValues: FleetVehicleEditFormValues,
  t: (key: string) => string
): Promise<FleetVehicle> => {
  const response = await createApiCall(
    {
      path: "/v1/fleet/vehicles/",
      method: "POST",
      body: transformFleetVehicleOnCreate(formValues),
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  invalidateDropdownCache(DropdownCacheKey.FleetVehicles);
  return transformFleetVehicle(response.data);
};

/*---------------------------------------------------------------------------------------
    UPDATE
  -----------------------------------------------------------------------------------------*/
export const updateFleetVehicleAPI = async (
  id: string,
  formValues: FleetVehicleEditFormValues,
  t: (key: string) => string
): Promise<FleetVehicle> => {

  const response = await createApiCall(
    {
      path: `/v1/fleet/vehicles/${id}`,
      method: "PUT",
      body: transformFleetVehicleOnUpdate(formValues),
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  invalidateDropdownCache(DropdownCacheKey.FleetVehicles);
  return transformFleetVehicle(response.data);
};

/*---------------------------------------------------------------------------------------
    UPDATE
  -----------------------------------------------------------------------------------------*/
export const publishFleetVehicleAPI = async (
  id: string,
  formValues: FleetVehicleEditFormValues,
  t: (key: string) => string
): Promise<any> => {

  const response = await createApiCall(
    {
      path: `/v1/fleet/vehicles/${id}/publish`,
      method: "PUT",
      body: { vehicleId: id },
    },
    {
      getMessage: {
        success: () => `${t("admin.fleet.vehicle.update.message.success")}`,
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();


  return response.data;
};

/*---------------------------------------------------------------------------------------
    UPDATE REGISTRATION
  -----------------------------------------------------------------------------------------*/
export const updateFleetVehicleRegistrationAPI = async (
  id: string,
  registrationPlate: string,
  registrationExpiration: Date | null,
  t: (key: string) => string
): Promise<FleetVehicle> => {
  const response = await createApiCall(
    {
      path: `/v1/fleet/vehicles/${id}/registration`,
      method: "PATCH",
      body: transformFleetVehicleRegistrationOnCreate(registrationPlate, registrationExpiration),
    },
    {
      getMessage: {
        success: () => t("admin.fleet.vehicle.registration.update.success"),
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformFleetVehicle(response.data);
};

/*---------------------------------------------------------------------------------------
    UPDATE MILEAGE
  -----------------------------------------------------------------------------------------*/
export const updateFleetVehicleMileageAPI = async (
  id: string,
  kmTraveled: number,
  t: (key: string) => string
): Promise<FleetVehicle> => {
  const response = await createApiCall(
    {
      path: `/v1/fleet/vehicles/${id}/mileage`,
      method: "PATCH",
      body: { kmTraveled },
    },
    {
      getMessage: {
        success: () => t("admin.fleet.vehicle.mileage.update.success"),
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformFleetVehicle(response.data);
};

/*---------------------------------------------------------------------------------------
    BOJE
  -----------------------------------------------------------------------------------------*/

export const getFleetVehicleColorAPI = async (): Promise<
  FleetVehicleColor[]
> => {

  const response = await createApiCall(
    {
      path: `/v1/fleet/vehicles/colors`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return response.data.map(transformFleetVehicleColor);
};

/*---------------------------------------------------------------------------------------
  VEHICLE WIZARD STEPS - GET (uključeni koraci wizarda po tenantu)
-----------------------------------------------------------------------------------------*/
export const getVehicleWizardStepsAPI = async (): Promise<string[]> => {
  const response = await createApiCall(
    {
      path: `/v1/fleet/vehicles/wizard-steps`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return response.data?.enabledVehicleStepKeys || [];
};

/*---------------------------------------------------------------------------------------
  VEHICLE ECO FEE - GET (naknada Fondu za zaštitu okoliša za vozilo)
-----------------------------------------------------------------------------------------*/
export interface VehicleEcoFee {
  amount: number;
  massFee: number;
  tireFee: number;
  mass: number | null;
  categoryCode: string | null;
  isElectric: boolean;
  tireCount: number;
}

export const getVehicleEcoFeeAPI = async (id: string): Promise<VehicleEcoFee> => {
  const response = await createApiCall(
    {
      path: `/v1/fleet/vehicles/${id}/eco-fee`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return {
    amount: response.data?.amount ?? 0,
    massFee: response.data?.massFee ?? 0,
    tireFee: response.data?.tireFee ?? 0,
    mass: response.data?.mass ?? null,
    categoryCode: response.data?.categoryCode ?? null,
    isElectric: !!response.data?.isElectric,
    tireCount: response.data?.tireCount ?? 0,
  };
};

/*---------------------------------------------------------------------------------------
    EXPORT
  -----------------------------------------------------------------------------------------*/
export const exportFleetVehiclesAPI = async (
  vehicleIds: string[]
): Promise<AxiosResponse> => {
  const response = await createApiCall(
    {
      path: `/v1/fleet/vehicles/export`,
      method: "POST",
      body: { vehicleIds },
      responseType: "blob",
    },
    {
      getMessage: {
        success: () => "Datoteka je uspješno exportana",
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return response;
};

/*---------------------------------------------------------------------------------------
    IMPORT
  -----------------------------------------------------------------------------------------*/
export const importFleetVehiclesAPI = async (
  file: File
): Promise<VehicleImportResult> => {
  const formData = new FormData();
  formData.append("file", file);

  const config = {
    headers: { Authorization: `Bearer ${getAccessToken()}` },
  };

  const response = await filesApi.post(
    `/v1/fleet/vehicles/import`,
    formData,
    config
  );

  return {
    successCount: response.data?.successCount ?? 0,
    errors: response.data?.errors ?? [],
  };
};

/*---------------------------------------------------------------------------------------
    IMPORT PO JOM BROJU
  -----------------------------------------------------------------------------------------*/
export const importFleetVehiclesFromJomAPI = async (
  items: JomImportRequestItem[]
): Promise<VehicleImportResult> => {
  const response = await createApiCall(
    {
      path: `/v1/fleet/vehicles/import-jom`,
      method: "POST",
      body: { items },
    },
    {
      getMessage: {
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return {
    successCount: response.data?.successCount ?? 0,
    errors: response.data?.errors ?? [],
  };
};

/*---------------------------------------------------------------------------------------
    IMPORT TEMPLATE DOWNLOAD
  -----------------------------------------------------------------------------------------*/
export const getFleetVehiclesImportTemplateAPI = async (): Promise<AxiosResponse> => {
  const response = await createApiCall(
    {
      path: `/v1/fleet/vehicles/import/template`,
      method: "GET",
      responseType: "blob",
    },
    {
      getMessage: {
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return response;
};

/*---------------------------------------------------------------------------------------
    DELETE
  -----------------------------------------------------------------------------------------*/
export const deleteFleetVehicleAPI = async (
  id: string,
  t: (key: string) => string
): Promise<boolean> => {
  const response = await createApiCall(
    {
      path: `/v1/fleet/vehicles/${id}`,
      method: "DELETE",
    },
    {
      getMessage: {
        success: () => t("admin.fleet.vehicle.delete.message.success"),
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  invalidateDropdownCache(DropdownCacheKey.FleetVehicles);
  return response.data?.deleted;
};

/*---------------------------------------------------------------------------------------
    UPDATE STATUS
  -----------------------------------------------------------------------------------------*/
export const updateFleetVehicleStatusAPI = async (
  id: string,
  status: string,
  t: (key: string) => string,
  details?: FleetVehicleStatusDetailFormValues | null
): Promise<FleetVehicle> => {
  const response = await createApiCall(
    {
      path: `/v1/fleet/vehicles/${id}/status`,
      method: "PATCH",
      body: { status, ...transformFleetVehicleStatusDetailOnSave(details) },
    },
    {
      getMessage: {
        success: () => t("admin.fleet.vehicle.status.update.success"),
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformFleetVehicle(response.data);
};

/*---------------------------------------------------------------------------------------
    STATUS HISTORY
  -----------------------------------------------------------------------------------------*/
export const getFleetVehicleStatusHistoryAPI = async (
  id: string
): Promise<FleetVehicleStatusHistoryRow[]> => {
  const response = await createApiCall(
    {
      path: `/v1/fleet/vehicles/${id}/status-history`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return response.data.map(transformFleetVehicleStatusHistoryRow);
};
